import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { InfoLinkSection } from 'src/components/Reusable/Text/InfoLink.styles'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { ControlsAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { HelpPages } from 'src/pages/Help/Help.constants'
import { LearnMoreLink } from 'src/components/Reusable/Text/Link'
import {
  AuditBotEmptyContainer,
  AuditBotControlsEmptyIcon,
  AuditBotEmptyTitle,
  AuditBotEmptyDescription,
  AuditBotEmptyButtonContainer,
} from '../AuditBotModal.styles'

export const AuditBotControlsDescription = (): JSX.Element => {
  return (
    <InfoLinkSection>
      Control Test will test these controls. All controls must pass for audit
      readiness. <LearnMoreLink href={HelpPages['Overview'].link} />
    </InfoLinkSection>
  )
}

export const AuditBotControlsEmptyState = ({
  onHide,
}: {
  onHide: () => void
}): JSX.Element => {
  const navigate = useNavigate()
  const params = useParams()
  const url = `/${params.pageContext}/${ControlsAbsoluteRoutes.INDEX}`

  return (
    <AuditBotEmptyContainer>
      <AuditBotEmptyTitle>
        <AuditBotControlsEmptyIcon />
        This audit contains no controls.
      </AuditBotEmptyTitle>
      <AuditBotEmptyDescription>
        The audit must contain controls before testing can begin.
      </AuditBotEmptyDescription>
      <AuditBotEmptyButtonContainer>
        <StandardButton
          buttonSize={StandardButtonSize.MEDIUM}
          variant={StandardButtonVariant.PRIMARY}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            onHide()
            navigate(url)
          }}
        >
          Add Controls to the Audit
        </StandardButton>
      </AuditBotEmptyButtonContainer>
    </AuditBotEmptyContainer>
  )
}
